import React from 'react';

import { LazySecurityConfigurationPage } from '@confluence/site-settings/entry-points/SecurityConfigurationPage.ts';
import { ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/securityConfigurationConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminSecurityConfigurationRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazySecurityConfigurationPage />;

AdminSecurityConfigurationRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
